module.exports = __webpack_public_path__ + "img/sanctuary-pic-mobile.0c806ee5.webp";